<template>
  <button
    class="app-modal-close"
    type="button"
    :aria-label="label"
    title="Close"
    @click="$emit('click', $event)"
  >
    <span class="app-modal-close__icon" aria-hidden="true"></span>
  </button>
</template>

<script>
export default {
  name: 'AppModalClose',
  props: {
    label: { type: String, default: 'Close' },
    design: {
      type: String,
      required: true,
      validator: value => value === 'new'
    }
  },
  methods: {
    focus() { this.$el.focus() }
  }
}
</script>

<style lang="scss" scoped>
.app-modal-close {
  display: inline-flex;
  width: $ui-control-height;
  height: $ui-control-height;
  flex: 0 0 $ui-control-height;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid $ui-line-strong;
  border-radius: $ui-control-radius;
  background-color: $ui-surface;
  color: $ui-muted;
  cursor: pointer;

  &:hover {
    border-color: $ui-blue;
    background-color: $ui-surface-soft;
    color: $ui-blue;
  }

  &:focus-visible {
    outline: 2px solid $ui-blue;
    outline-offset: 2px;
  }
}

.app-modal-close__icon {
  position: relative;
  display: block;
  width: 14px;
  height: 14px;

  &::before,
  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 2px;
    border-radius: 1px;
    background-color: currentColor;
    content: '';
  }

  &::before { transform: translate(-50%, -50%) rotate(45deg); }
  &::after { transform: translate(-50%, -50%) rotate(-45deg); }
}
</style>
